















import { Component, Prop, Vue } from "vue-property-decorator";
import CzIcon from "./CzIcon.vue";
import CzChip from "./CzChip.vue";

@Component({ components: { CzIcon, CzChip } })
export default class CzListRow extends Vue {
  @Prop({ type: [String, Object], default: "" }) to!: string | object;
  @Prop({ type: String, required: true }) icon!: string;
  @Prop({ type: String, required: true }) label!: string;
  @Prop({ type: String, default: "" }) badge!: string;
}
